<template>
  <BaseModal :modalTitle="$t('W: Opdater modtagelsesdato')">
    <div class="mb-4 flex flex-col gap-3">
      <span class="text-sm text-text-muted">
        {{ $t('W: Vælg den dato og det tidspunkt, som leveringstiderne skal beregnes fra') }}
      </span>

      <div class="flex gap-3">
        <input
          type="date"
          v-model="dateStr"
          class="rounded-md border border-border-subtle px-3 py-1.5 text-sm focus:border-action focus:outline-none" />
        <input
          type="time"
          v-model="timeStr"
          class="rounded-md border border-border-subtle px-3 py-1.5 text-sm focus:border-action focus:outline-none" />
      </div>
    </div>

    <template #buttons>
      <UiBaseButton
        :text="$t('action.cancel')"
        theme="neutral"
        :isDisabled="isLoading"
        @button-click="$emit('close')" />
      <UiBaseButton
        :text="$t('action.save')"
        theme="primary"
        :isLoading="isLoading"
        :showSaveIcon="showSaveIcon"
        @button-click="onSaveClick" />
    </template>
  </BaseModal>
</template>

<script lang="ts">
import { mapActions, mapState } from 'pinia'
import { useAppStore } from '@/stores/appStore'
import { useOrderStore } from '@/stores/orderStore'
import { useToast } from '@/globals/typescript/utils/toast'

export default {
  name: 'UpdateOrderTatStartDateModal',

  emits: ['close'],

  props: {
    orderID: { type: String, required: true },
    currentTatStartDate: { type: Number, default: null },
  },

  data() {
    const base = this.currentTatStartDate != null ? new Date(this.currentTatStartDate) : new Date()
    return {
      dateStr: `${base.getFullYear()}-${String(base.getMonth() + 1).padStart(2, '0')}-${String(base.getDate()).padStart(2, '0')}`,
      timeStr: `${String(base.getHours()).padStart(2, '0')}:${String(base.getMinutes()).padStart(2, '0')}`,
      isLoading: false,
      showSaveIcon: false,
    }
  },

  computed: {
    ...mapState(useAppStore, ['defaultMessageSaveIconTime']),
  },

  methods: {
    ...mapActions(useOrderStore, ['updateOrderTatStartDate']),

    async onSaveClick(): Promise<void> {
      const [year = 0, month = 0, day = 0] = this.dateStr.split('-').map(Number)
      const [hours = 0, minutes = 0] = this.timeStr.split(':').map(Number)
      const tatStartDate = new Date(year, month - 1, day, hours, minutes).getTime()

      this.isLoading = true
      try {
        await this.updateOrderTatStartDate(this.orderID, tatStartDate)
        this.showSaveIcon = true
        setTimeout(() => {
          this.showSaveIcon = false
        }, this.defaultMessageSaveIconTime)
        useToast().success(this.$t('W: Modtagelsesdato opdateret'))
        this.$emit('close')
      } catch {
        useToast().error(this.$t('W: Kunne ikke opdatere modtagelsesdato'))
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
